{
  "name": "@ns/commercial-relationship-review",
  "version": "1.1.0",
  "requiredPermission": "RELATIONSHIPS_MANAGE",
  "description": "Prompts the client to review an active commercial relationship",
  "inputs": {
    "relationshipId": {
      "type": "string"
    }
  },
  "outcomes": {
    "reviewed": {}
  }
}
